import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getQueryString } from '@/util/index'

// 国际化
Vue.use(VueI18n); 
const messages = {
  'zh_CN': require('../locales/zh-CN.json'),
  'en_US': require('../locales/en.json'),
  'id_ID': require('../locales/id_ID.json'),
  'th_TH': require('../locales/th-TH.json'),
  'ms_MY': require('../locales/ms_MY.json'),
  'vi_VN': require('../locales/vi_VN.json'),
  'ar_AE': require('../locales/ar_AE.json')
}
export default new VueI18n({
    messages,
    locale:(getQueryString('lang') && getQueryString('lang').replace(/-/g, "_")) || localStorage.getItem('language') || `zh_CN`
});


// WEBPACK FOOTER //
// src/util/lang.js